<template>
  <el-card class="box-card  top-border">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-s-data text-blue" style="margin-right: 5px;"></i>{{title}}（{{employeeName}}）</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" class="tabs-filter-wrapper">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="月绩效" name="month"></el-tab-pane>
          <el-tab-pane label="季度绩效" name="quarter"></el-tab-pane>
          <el-tab-pane label="年绩效" name="year"></el-tab-pane>
        </el-tabs>

        <div class="filter-container">
          <el-select v-model="year" placeholder="年份" size="small" style="width: 100px; margin-right: 10px;" @change="fetchData">
            <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"></el-option>
          </el-select>

          <el-select v-if="activeTab === 'month'" v-model="month" placeholder="月份" size="small" style="width: 100px; margin-right: 10px;" @change="fetchData">
            <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"></el-option>
          </el-select>

          <el-select v-if="activeTab === 'quarter'" v-model="quarter" placeholder="季度" size="small" style="width: 100px; margin-right: 10px;" @change="fetchData">
            <el-option v-for="q in 4" :key="q" :label="'第' + q + '季度'" :value="q"></el-option>
          </el-select>

          <el-button type="primary" icon="el-icon-search" size="small" @click="fetchData">查询</el-button>
        </div>
      </div>

      <div v-show="isExpanded" v-loading="loading" class="metrics-container">
      <el-row :gutter="20" type="flex" align="middle">
        <!-- 左侧：达成率 -->
        <el-col :span="6" class="achievement-col">
          <div class="achievement-wrapper">
            <el-progress
              type="circle"
              :percentage="Number(data.achievementRate) > 100 ? 100 : Number(data.achievementRate)"
              :width="150"
              :stroke-width="15"
              stroke-linecap="round"
              :color="achievementColor"
              :format="achievementFormat"
            ></el-progress>
            <div class="achievement-label">达成率</div>
          </div>
        </el-col>

        <!-- 右侧：其他指标 -->
        <el-col :span="18">
          <!-- 上部：4个核心指标 -->
          <el-row :gutter="20" class="mb-20">
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-content">
                  <div class="metric-title">
                    目标数
                  </div>
                  <div class="metric-value">{{ data.target }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-content">
                  <div class="metric-title">
                    成交数
                  </div>
                  <div class="metric-value">{{ data.completed }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-content">
                  <div class="metric-title">
                    成交金额
                  </div>
                  <div class="metric-value">¥{{ data.amount | numberFormat }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-content">
                  <div class="metric-title">
                    新增流量
                  </div>
                  <div class="metric-value">{{ data.newTraffic }}</div>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 下部：对比数据 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="comparison-box">
                <h4>环比流量对比</h4>
                <div class="comparison-content">
                  <div>本期: {{ data.trafficComparison.current }}</div>
                  <div>上期: {{ data.trafficComparison.previous }}</div>
                  <div>
                    增长:
                    <span :class="data.trafficComparison.growthRate >= 0 ? 'text-success' : 'text-danger'">
                      {{ data.trafficComparison.growthRate }}%
                      <i :class="data.trafficComparison.growthRate >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                    </span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="comparison-box">
                <h4>团队对比 (均值)</h4>
                <div class="comparison-content">
                  <div>成交量: {{ data.teamComparison.avgCompleted }}</div>
                  <div>成交额: ¥{{ data.teamComparison.avgAmount | numberFormat }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="comparison-box commission-box">
                <h4>预估提成</h4>
                <div class="comparison-content">
                  <div>
                    提成金额:
                    <el-tooltip placement="top">
                      <div slot="content">
                        成交提成：¥{{ (commissionData.commissionAmount || 0).toLocaleString() }}<br/>
                        续签提成：¥{{ renewCommission.toLocaleString() }}
                      </div>
                      <span style="color: #667eea; cursor: pointer;">¥{{ totalCommission.toLocaleString() }}</span>
                    </el-tooltip>
                  </div>
                  <div>提成比例: {{ commissionData.commissionRate || 0 }}%</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { renewCommissionRate } from '@/utility/staticData'

export default {
  name: 'Performance',
  props: {
    targetType: {
      type: String,
      default: 'personal'
    },
    url: {
      type: String,
      default: 'zhaoshang/zhuanyuan/performance'
    },
    employeeId: {
      type: String,
      default: ''
    },
    employeeName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isExpanded: true,
      activeTab: 'month',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      quarter: Math.ceil((new Date().getMonth() + 1) / 3),
      loading: false,
      data: {
        achievementRate: 0,
        target: 0,
        completed: 0,
        amount: 0,
        newTraffic: 0,
        trafficComparison: {
          current: 0,
          previous: 0,
          growthRate: 0
        },
        teamComparison: {
          avgCompleted: 0,
          avgAmount: 0
        }
      },
      commissionData: {
        totalAmount: 0,
        commissionRate: 0,
        commissionAmount: 0
      }
    }
  },
  computed: {
    title () {
      if (this.targetType === 'group') {
        return '团队绩效'
      } else if (this.targetType === 'department') {
        return '部门绩效'
      }
      return '个人绩效'
    },
    yearOptions () {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let i = 0; i < 5; i++) {
        years.push(currentYear - i)
      }
      return years
    },
    achievementColor () {
      const rate = this.data.achievementRate
      if (rate < 60) return '#a0cfff' // 浅蓝
      if (rate < 80) return '#62affe' // 标准蓝
      if (rate < 100) return '#3699ff' // 蓝紫过渡
      return '#007eff' // 蓝紫
    },
    // 续签金额 = 成交金额 - 收款金额（仅专员工作台调用了 commission 接口时有效）
    renewAmount () {
      if (!this.url.includes('zhuanyuan')) return 0
      return Math.max(0, (this.data.amount || 0) - (this.commissionData.totalAmount || 0))
    },
    // 续签提成 = 续签金额 × 续签提成比例（renewCommissionRate，见 staticData.js）
    renewCommission () {
      return Math.round(this.renewAmount * renewCommissionRate * 100) / 100
    },
    // 总提成 = 成交提成 + 续签提成
    totalCommission () {
      const deal = this.commissionData.commissionAmount || 0
      return Math.round((deal + this.renewCommission) * 100) / 100
    }
  },
  filters: {
    numberFormat (value) {
      if (!value) return '0'
      return value.toLocaleString()
    }
  },
  created () {
    // this.fetchData()
  },
  watch: {
    employeeId: {
      handler () {
        if (this.employeeId) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    },
    handleTabClick (tab) {
      this.activeTab = tab.name
      this.fetchData()
    },
    achievementFormat (percentage) {
      return `${this.data.achievementRate || 0}%`
    },
    async fetchData () {
      this.loading = true
      try {
        const params = {
          type: this.activeTab,
          year: this.year,
          targetType: this.targetType
        }
        if (this.activeTab === 'month') {
          params.month = this.month
        } else if (this.activeTab === 'quarter') {
          params.quarter = this.quarter
        }
        if (this.employeeId) {
          params.employeeId = this.employeeId
        }

        const { data: res } = await this.$http.get(this.url, { params })

        if (res.meta.status === 200) {
          this.data = res.data
        } else {
          this.$message.error(res.meta.msg)
        }

        // 获取提成数据
        if (this.url.includes('zhuanyuan')) {
          try {
            const commissionRes = await this.$http.get('zhaoshang/performance/commission', { params })
            if (commissionRes.data.meta.status === 200) {
              this.commissionData = commissionRes.data.data
            }
          } catch (e) {
            console.error('获取提成数据失败', e)
          }
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取绩效数据失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  background: linear-gradient(to bottom, #f0f9ff 0%, #ffffff 100%);
  border-radius: 8px;
}
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.tabs-filter-wrapper {
  position: relative;
}
.filter-container {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.metrics-container {
  padding: 10px 0;
}
.achievement-col {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #ebeef5;
}
.achievement-wrapper {
  text-align: center;
}
.achievement-wrapper ::v-deep .el-progress__text {
  font-size: 32px !important;
  font-weight: bold;
}
.achievement-label {
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #606266;
}
.metric-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}
.metric-item:hover {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.metric-content {
  text-align: left;
  width: 100%;
}
.metric-title {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
}
.metric-title i {
  margin-right: 4px;
  font-size: 14px;
}
.metric-value {
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  line-height: 1.2;
}
.text-blue { color: #409EFF; }
.text-orange { color: #e6a23c; }
.text-green { color: #67c23a; }

.comparison-box {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  height: 100%;
}
.comparison-box h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #606266;
  font-size: 14px;
}
.comparison-content {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #606266;
}
.commission-box {
  background-color: #f5f7fa;
}
.text-success {
  color: #67c23a;
}
.text-danger {
  color: #f56c6c;
}
.mb-20 {
  margin-bottom: 20px;
}
.top-border {
  border-top: 3px solid #409EFF;
  box-sizing: border-box;
}
</style>
